<template>
  <MultiImageSliderStrip
    :slides-data="records"
    :slider-breakpoints="sliderBreakpoints">
    <template #image-slide="{ record, recordIndex }">
      <img
        :src="record.imageThumb"
        class="s-multi-img-slider__image-slide"
        :alt="record.alt"
        @click="openImageGalleryModal(recordIndex)" />
    </template>
  </MultiImageSliderStrip>
  <ModalOverlay
    v-model="showPhotoGallery"
    photo-gallery-modal
    downloadable-photos
    :swiper-data="photoGalleryData"
    background-class="b-pop-up--video b-pop-up__holder"
    header-background-class="b-pop-up__header"
    :initial-slide-index="initialSlideIndex"
    :link-download-text="dictionary.linkDownload">
    <template #header>
      <div v-if="dictionary.modalTitle" class="b-pop-up__header__title">
        {{ dictionary.modalTitle }}
      </div>
    </template>
  </ModalOverlay>
</template>

<script setup>
import { computed, getCurrentInstance, onBeforeMount, ref } from 'vue'
import MultiImageSliderStrip from '../components/MultiImageSliderStrip.vue'
import ModalOverlay from '../components/ModalOverlay.vue'
import { getData } from '../../lib/lib'

const { dictionary, suffix } =
  getCurrentInstance().appContext.config.globalProperties
const records = ref([])
const initialSlideIndex = ref(0)

const sliderBreakpoints = ref({
  320: {
    slidesPerView: 1.05,
    spaceBetween: 8,
  },
  576: {
    slidesPerView: 1.5,
    spaceBetween: 16,
  },
  768: {
    slidesPerView: 2.2,
    spaceBetween: 16,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 32,
  },
  1279: {
    slidesPerView: 3,
    spaceBetween: 32,
  },
})
const showPhotoGallery = ref(false)

const photoGalleryData = computed(() => {
  return records.value.map((slide) => slide.image)
})

onBeforeMount(() => {
  const { records: cards } = getData(`multiImageSliderData${suffix}`)
  records.value = [...cards]
})

const openImageGalleryModal = (recordIndex) => {
  initialSlideIndex.value = recordIndex
  showPhotoGallery.value = true
}
</script>
